angular
  .module('contrast.factory.profile', [])
  .factory('ProfileFactory', function ($http) {
    return {
      //all of these methods do not require orgUuid
      getProfile: function (expandValue) {
        return $http.get('/Contrast/api/ng/profile', {
          params: { expand: expandValue }
        })
      },
      getRoles: function () {
        return $http.get('/Contrast/api/ng/profile/roles')
      },
      getAdditivePolicy: function () {
        return $http.get('/Contrast/api/ng/profile/passwordpolicy')
      },
      getDefaultOrganization: function () {
        return $http.get('/Contrast/api/ng/profile/organizations/default', {
          params: { expand: ['freemium', 'rbac'] }
        })
      },
      getOrganization: function (orgUuid) {
        return $http.get('/Contrast/api/ng/profile/organizations/' + orgUuid, {
          params: { expand: 'freemium' }
        })
      },
      getAllowedOrganizations: function () {
        return $http.get('/Contrast/api/ng/profile/organizations', {
          params: { expand: 'freemium' }
        })
      },
      getKeys: function () {
        return $http.get('/Contrast/api/ng/profile/servicekey')
      },
      rotateUserKey: function () {
        return $http.put('/Contrast/api/ng/profile/servicekey/rotate')
      },
      updatePasswordProfile: function (currentpassword, newpassword) {
        return $http.put('/Contrast/api/ng/profile/password', {
          old_password: currentpassword,
          new_password: newpassword
        })
      },
      validatePassword: function (password) {
        return $http.post('/Contrast/api/ng/profile/password/validate', {
          password: password
        })
      },
      updateExpiredPassword: function (newpassword, oldPassword) {
        return $http.put('/Contrast/api/ng/profile/expired', {
          password: newpassword,
          oldPassword: oldPassword
        })
      },
      saveProfile: function (profile) {
        return $http.put('/Contrast/api/ng/profile', {
          first_name: profile.firstname,
          last_name: profile.lastname,
          date_format: profile.dateformat,
          time_format: profile.timeformat,
          time_zone: profile.timezone,
          language: profile.language
        })
      },
      setDefaultOrg: function (orgUuid) {
        return $http({
          url: '/Contrast/api/ng/profile/' + orgUuid + '/default',
          method: 'PUT',
          params: { expand: 'freemium' }
        })
      },
      getOrgDiagnosticsSettings: function (orgUuid) {
        return $http.get(
          '/Contrast/api/ng/' + orgUuid + '/settings/diagnostics',
          {
            orgUuid: orgUuid
          }
        )
      },
      getUserActions: function (orgUuid) {
        return $http.get(
          `/Contrast/api/ng/organizations/${orgUuid}/access-control-query/users`
        )
      },
      getResourceGroupsByAction: function (orgUuid, action) {
        return $http.get(
          `/api/ui/organizations/${orgUuid}/access-control-query/action/${action}/resource-groups`
        )
      },
      getResourceGroupsForUserByAction: function (orgUuid, userId, action) {
        return $http.get(
          `/api/v4/organizations/${orgUuid}/access-control-query/users/${userId}/resource-groups?action=${action}`
        )
      },
      getFreeTrialOrgData: function (orgUuid) {
        return $http.get(
          `/Contrast/api/ng/free-trial/organizations/${orgUuid}/current-user`
        )
      }
    }
  })
